import { generate } from '@ant-design/colors';

export const primaryColor = '#D16C44';

export const darkMode = 'light';

type GenerateTheme = 'default' | 'dark';

export function generateAntColors(color: string, theme: GenerateTheme = 'default') {
  return generate(color, {
    theme,
  });
}

export function getThemeColors(color?: string) {
  const tc = color || primaryColor;
  const lightColors = generateAntColors(tc);
  const primary = lightColors[5];
  const modeColors = generateAntColors(primary, 'dark');

  return [...lightColors, ...modeColors];
}
